import { render, staticRenderFns } from "./purchase-item.vue?vue&type=template&id=0df024ba&scoped=true&"
import script from "./purchase-item.vue?vue&type=script&lang=js&"
export * from "./purchase-item.vue?vue&type=script&lang=js&"
import style0 from "./purchase-item.vue?vue&type=style&index=0&id=0df024ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df024ba",
  null
  
)

export default component.exports